import { Organization } from "types/Organization";

const enableMapField = (organization?: Organization, isGeo?: boolean) => {
  return organization?.activeModuleMap && isGeo;
};

export default enableMapField;
